<template>
    <v-container style="position: relative">
        <div class="text-right mb-4">
            <v-btn
                @click="creationDialog = true"
                color="primary"
                rounded
            >
                Buat baru
            </v-btn>
        </div>

        <input-dialog
            v-model="creationDialog"
            @save="create"
            title="Buat Keahlian Baru"
            label="Nama bidang"
        ></input-dialog>

        <input-dialog
            v-model="editDialog"
            @save="update"
            title="Edit bidang keahlian"
            label="Nama bidang"
            :initialValue="selectedFieldName"
        ></input-dialog>

        <v-skeleton-loader
            v-if="!fields"
            type="table-tbody"
        ></v-skeleton-loader>

        <v-simple-table
            v-else
            class="elevation-1"
        >
            <thead>
                <tr>
                    <th>Nama</th>
                    <th>Total Soal</th>
                    <th>Aksi</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(field, idx) in fields"
                    :key="field.id"
                >
                    <td>
                        {{ field.title }}
                    </td>
                    <td>
                        {{ field.question_count }}
                    </td>
                    <td>
                        <v-btn
                            @click="edit(idx)"
                            icon
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                            @click="deleteConfirmation(idx)"
                            icon
                        >
                            <v-icon color="error">mdi-delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <confirmation-dialog
            @confirmed="deleteField"
            v-model="deleteDialog"
            title="Hapus bidang keahlian?"
            subtitle="Menghapus akan menghilangkan bidang keahlian dari soal yang memiliki bidang keahlian ini"
            color="error"
            actionText="Hapus"
        ></confirmation-dialog>
    </v-container>
</template>

<script>
import InputDialog from '@/components/dashboard/field/InputDialog'
import ConfirmationDialog from '@/components/ConfirmationDialog'

export default {
    components: {
        InputDialog,
        ConfirmationDialog,
    },

    data() {
        return {
            fields: null,
            creationDialog: false,
            editDialog: false,
            deleteDialog: false,
            selectedFieldIdx: null,
        }
    },

    computed: {
        selectedFieldName() {
            if (this.selectedFieldIdx !== null) {
                return this.fields[this.selectedFieldIdx].title
            }

            return null
        },

        selectedFieldId() {
            if (this.selectedFieldIdx !== null) {
                return this.fields[this.selectedFieldIdx].id
            }

            return null
        },
    },

    methods: {
        getData() {
            this.$api
                .get('field', { loader: 'appbar' })
                .then((response) => (this.fields = response.data.fields))
        },

        create(title) {
            this.$api
                .post(
                    'field',
                    {
                        title,
                    },
                    { loader: 'appbar' }
                )
                .then(this.getData)
        },

        edit(idx) {
            this.selectedFieldIdx = idx
            this.editDialog = true
        },

        update(title) {
            this.$api
                .patch(
                    `field/${this.selectedFieldId}`,
                    {
                        title,
                    },
                    { loader: 'appbar' }
                )
                .then(this.getData)
        },

        deleteConfirmation(idx) {
            this.selectedFieldIdx = idx
            this.deleteDialog = true
        },

        deleteField() {
            this.$api
                .delete(`field/${this.selectedFieldId}`, { loader: 'appbar' })
                .then(() => {
                    this.selectedFieldIdx = null
                    this.getData()
                })
        },
    },

    created() {
        this.getData()
    },
}
</script>
